module.exports = __webpack_public_path__ + "d0e39d465f6816a2af77743158ac7977.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_3_tri.mp3
 ** module id = 177
 ** module chunks = 0
 **/